import { Component, OnInit } from '@angular/core';
import { AdminService } from "../../services/admin.service";
import { NotificationsService } from "angular2-notifications";
import { UserService } from "../../services/user.service";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
    adminList={
        name:'',
        group:''
    };
    menulist = [];
    menulists = [];

    submenlist = {};
    admindetails = {
        _id: ''
    }
    // permission = false;
    // val = true;
    constructor(
        private adminService: AdminService,
        private notifSer: NotificationsService,
        private userService: UserService,
        private router: Router,
        ) {}
    envcheck:any;
    colordiff:any;
    ngOnInit() {
        this.envcheck=environment.name;
        if(this.envcheck === 'local'){
          this.colordiff='icon-w '
        }else if (this.envcheck === 'test'){
          this.colordiff='icon-w'
        }else if(this.envcheck === 'prod'){
          this.colordiff='icon-w test'
        }else{
    
        }
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            // this.permission = this.global.setPermission(this.val)
            this.admindetails = this.userService.getUserDetails();
            this.getadmin();
            this.getMenu();
            this.adminService.groupupdate.subscribe(currency => {
                this.getMenu();
            })
        }

    }
    getadmin() {
        this.userService.getCustomerDetailsById(this.admindetails._id).subscribe(done => {
            this.adminList = done;
        }, (err) => {
            this.notifSer.error(
                'Error',
                'Could Not Load Admin Detail',
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    getMenu() {
        this.adminService.getAdminPanelMenus().subscribe((success) => {
            var adminrules = success.adminrules;
            var menus = success.menus;
            // console.log("TEST",success);
            localStorage.setItem("adminrules",JSON.stringify(adminrules))
            localStorage.setItem("adminmenus",JSON.stringify(menus))
            this.menulists = [];

            this.submenlist = [];
            var submenulist = []; 
            for(var i=0; i<adminrules.length;i++)

            {
                for(var j=0; j<menus.length;j++)
                {
                    if(menus[j].menu !=='Manage KYC' && menus[j].menu !=='Manage KYC Plan' && menus[j].menu !== 'Manage Announcement' && menus[j].menu !== 'Content Management System'){
                        if(adminrules[i].menu_id.toString() == menus[j]._id.toString())
                        {
                            // console.log("ok",menus[j]._id);
                            if(typeof menus[j].parentmenu != "undefined")
                            {
                                if (Object.keys(submenulist).indexOf(menus[j].parentmenu.toString()) === -1) {
                                                submenulist[menus[j].parentmenu] = [{
                                                    _id        : menus[j]._id.toString(),
                                                    permission :  adminrules[i].permission,
                                                    menu       : menus[j].menu,
                                                    menu_url   : menus[j].menu_url,
                                                    order      : menus[j].order,
                                                    styleclass : menus[j].styleclass,
                                                    status     : menus[j].status
                                                }]
                                } else {
                                    submenulist[menus[j].parentmenu].push({
                                        _id        : menus[j]._id.toString(),
                                        permission :  adminrules[i].permission,
                                        menu       : menus[j].menu,
                                        menu_url   : menus[j].menu_url,
                                        order      : menus[j].order,
                                        styleclass : menus[j].styleclass,
                                        status     : menus[j].status
                                    });
                                }
                                var menindex = menus.findIndex(x => (x._id) === menus[j].parentmenu);
                                var parmenindex = this.menulists.findIndex(x => (x._id) === menus[j].parentmenu);
                                if(menindex!= -1 && parmenindex==-1)
                                {
                                    this.menulists.push({
                                        _id        : menus[menindex]._id.toString(),
                                        permission :  adminrules[i].permission,
                                        menu       : menus[menindex].menu,
                                        menu_url   : menus[menindex].menu_url,
                                        order      : menus[menindex].order,
                                        styleclass : menus[menindex].styleclass,
                                        status     : menus[menindex].status
                                    })
                                }
                            }
                            else
                            {
                                // console.log(this.menulists,'this.menulists')
                                var obj = {
                                    menu       : menus[j].menu,
                                    _id        : menus[j]._id,
                                    menu_url   : menus[j].menu_url,
                                    order      : menus[j].order,
                                    styleclass : menus[j].styleclass,
                                    permission : adminrules[i].permission
                                }
                                var parmenindex = this.menulists.findIndex(x => (x._id) === menus[j]._id);
                                if(parmenindex==-1)
                                {
                                    this.menulists.push(obj)
                                }
                            }

                        }

                    }
                }
            }
            this.menulists.sort((a, b) => a.order - b.order)
            // console.log(this.menulists)
            this.submenlist = submenulist;
            // console.log(this.submenlist)

            localStorage.setItem('permission', "write");
        }, (error) => {
            this.notifSer.error(
                'Error',
                'Could not load menus',
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
        
    }

    
    

    isEmptyObject(obj) {
        return (obj && (Object.keys(obj).length === 0));
    }

    isUndefinedObject(obj) {
        return (typeof obj === 'undefined');
    }
}



// WEBPACK FOOTER //
// ./src/app/_layout/sidebar/sidebar.component.ts